<template>
	<div>
        <div class="img-color-overlay">
            <div class="container">
                <div class="row section-separator">
                    <div class="section-title col-sm-12">
                        <h3>{{ $t('projects.featuredProjects') }}</h3>
                    </div>
                    <div class="col-sm-12 mh-featured-item">
                        <v-carousel v-model="model" show-arrows-on-hover cycle interval="15000">
                            <v-carousel-item v-for="(project, i) in projects" :key="i">
                              <v-sheet justify="center" color="transparent" height="80%" width="90%" tile>
                                <v-row class="fill-height">
                                    <div class="col-sm-6">
                                        <div class="mh-featured-project-img shadow-2 wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">
                                            <img :src="project.imageUrl1" alt="" class="img-fluid" />
                                        </div>
                                        <div class="mh-featured-project-img shadow-2 wow fadeInUp mt-5" data-wow-duration="0.8s" data-wow-delay="0.2s">
                                            <v-row>
                                                <v-col cols="6">
                                                    <img :src="project.imageUrl2" alt="" />
                                                </v-col>
                                                <v-col cols="6">
                                                    <img :src="project.imageUrl3" alt="" />
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="mh-featured-project-content">
                                            <div class="project-category wow fadeInUp text-none" data-wow-duration="0.8s" data-wow-delay="0.4s">
                                                <a target="_blank" :href="project.projectLink" class="fs-30">
                                                    {{ project.name }}
                                                </a>
                                            </div>
                                            <h6 class="wow fadeInUp text-none mt-5" data-wow-duration="0.8s" data-wow-delay="0.5s">
                                                {{ project.period }}
                                            </h6>
                                            <span class="wow fadeInUp text-none" data-wow-duration="0.8s" data-wow-delay="0.6s">
                                                {{ project.technology }}
                                            </span>
                                            <p v-for="(description, i) in project.descriptions" :key="i" class="wow fadeInUp text-none mt-3 description" data-wow-duration="0.8s" data-wow-delay="0.7s">
                                                {{ description }}
                                            </p>
                                            <a target="_blank" :href="project.projectLink" class="btn btn-fill wow fadeInUp text-none mt-5" data-wow-duration="0.8s" data-wow-delay="0.8s">
                                                {{ $t('projects.viewProject') }}
                                            </a>
                                        </div>
                                    </div>
                                </v-row>
                              </v-sheet>
                            </v-carousel-item>
                        </v-carousel>
                    </div>
                </div>
                <div class="text-center mb-10">
                    <h5>
                        <a href="https://hxp.liuxin.online/projects" target="_blank">{{ $t('blog.showMore') }}</a>
                    </h5>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data(){
        return {
            model: 0,
            projects: [
                {
                    name: 'untrading.org App',
                    period: '2022年7月 - 至今',
                    technology: 'SpringBoot + Vue + MySQL',
                    imageUrl1: '/static/images/projects/untrading-app/1.png',
                    imageUrl2: '/static/images/projects/untrading-app/2.png',
                    imageUrl3: '/static/images/projects/untrading-app/3.png',
                    projectLink: 'https://untrading.org',
                    descriptions: [
                        'untrading.org 是一个基于通过 EIP-5173 实施开发的改进 NFTs  和 Cryptos 框架的代币化资产交易平台，通过自主研发的不可替代的未来奖励 (nFR) 框架解决了几个世纪以来交易中最棘手的一些问题，在创作者、买家和卖家之间创建了一个消除了交易中的零和思维和利益冲突的无需信任的流。',
                        '同时，该项目采用了业界最前沿的 Web3.0 技术，实现了去中心化的数据查询和交互，通过 Web3.js API 与智能合约进行交互，完成 NFTs 和 Cryptos 的铸造、封装、上市、购买、查询等功能。'
                    ]
                },
                {
                    name: 'untrading.org',
                    period: '2022年7月 - 2022年8月',
                    technology: 'SpringBoot + Vue + MySQL',
                    imageUrl1: '/static/images/projects/untrading/1.png',
                    imageUrl2: '/static/images/projects/untrading/2.png',
                    imageUrl3: '/static/images/projects/untrading/3.png',
                    projectLink: 'https://untrading.org',
                    descriptions: [
                        '基于 Ethereum 和 Polygon 区块链上改进的 EIP-5173 NFT 框架，untrading.org 创建了一个消除了交易中的零和思维和利益冲突的无需信任的流。',
                        '流体系：由一定数量的 NFTs 和 Cryptos 代币买家和卖家组成的去中心化利润 环回共享生态系统。',
                        '无零和博弈：流体系确保每个人在出售代币后都能从未来的增长中受益，共同创造长期财富。',
                        '无利益冲突：没有佣金，没有存款费用，没有转账费用，因此我们可以为您做正确的事情（而不是为我们带来最大利润的诡计）。'
                    ]
                },
                {
                    name: '体育场馆可持续运营智能化评价平台',
                    period: '2021年11月 - 2022年7月',
                    technology: 'SpringBoot + Vue + MySQL',
                    imageUrl1: '/static/images/projects/olympic-venues/1.png',
                    imageUrl2: '/static/images/projects/olympic-venues/2.png',
                    imageUrl3: '/static/images/projects/olympic-venues/3.png',
                    projectLink: 'http://www.gymsiep.cn',
                    descriptions: ['体育场馆可持续运营智能化评价平台以可视化的方式展示场馆信息、场馆运营数据、通过已有运营数据智慧预测场馆运营趋势，在多时间节点、多时间阶段、多个维度对所有场馆数据进行分析计算，对场馆 46 项运营指标进行智慧评价。此平台从体育场馆的可持续运营视角出发，以宏观维度关注体育场馆社会、经济、生态效益，创新性地建立场馆可持续运营评价指标体系，对选址与规模、体育工艺、智慧场馆、功能使用、场景转换、能源消耗、维修保养、收入与支出等 8 个维度场馆数据进行数据的挖掘、开发、智能运算，建立智能评价模型进行智慧评测。使用者可通过屏幕交互，浏览场馆各项分析数据，并有不同权限可保护用户数据。该平台不但能对场馆已实施运营阶段进行智慧运营评测，也能基于场馆数据对场馆未来运营进行智慧预测，更能将场馆运营数据与场馆建设联系起来，进行智能模拟建造，为体育场馆建设提供非常有价值的帮助。']
                },
                {
                    name: 'artWorm(z)',
                    period: '2021年10月 - 2022年3月',
                    technology: 'SpringBoot + Vue + MySQL',
                    imageUrl1: '/static/images/projects/artwormz/1.png',
                    imageUrl2: '/static/images/projects/artwormz/2.png',
                    imageUrl3: '/static/images/projects/artwormz/3.png',
                    projectLink: 'https://artwormz.com',
                    descriptions: ['artWormz 是一个由艺术家成员拥有的去中心化自治组织 (DAO)，是由 artWormz DAO 制作的获奖艺术家作品的综合集合。通过使用 NFT 技术，artWormz DAO 将加速对过去 30 年中各种有成就的艺术家创作的原创艺术品的影响，使艺术市场民主化，并用收益重新激励艺术家。']
                },
                {
                    name: 'iob.fi - Hedged Defi Pools',
                    period: '2020年9月 - 2021年10月',
                    technology: 'SpringBoot + Vue + MySQL',
                    imageUrl1: '/static/images/projects/iob.fi/1.png',
                    imageUrl2: '/static/images/projects/iob.fi/2.png',
                    imageUrl3: '/static/images/projects/iob.fi/3.png',
                    projectLink: 'https://iob.fi',
                    descriptions: ['iob.fi DAO 是一个由 DAO（去中心化自治组织）管理的、非托管的、链上 DeFi 对冲池管理器。通过 DAO、iob.fi 客户、开发商、流动性提供者、投资者和代币持有者可以控制政策、新功能和组织治理，使投资者有机会在一个地方投资所有资产类别，包括货币、股票、商品和指数。']
                },
                {
                    name: 'ioBots - Trading with rule-based algos™',
                    period: '2019年5月 - 2021年10月',
                    technology: 'SpringBoot + Vue + MySQL',
                    imageUrl1: '/static/images/projects/iobots/1.png',
                    imageUrl2: '/static/images/projects/iobots/2.png',
                    imageUrl3: '/static/images/projects/iobots/3.png',
                    projectLink: 'https://iobots.pro',
                    descriptions: [
                        'ioBots 是为 IOB 公司内部开发的一系列交易工具。除了生成 Cryptos 的买入和卖出信号外，ioBots 交易系统还试图将交易视为一个可交互操作组件的系统，包括价格反馈、交易策略解释、决策引擎、风险控制引擎、基于与其他 DeFi 平台的智能合约交互的订单引擎，以及持续的风险监控。平台为用户免费提供自研的交易信号、市场类型、综合指数、投资组合、资产管理等多项专属指标。',
                        '该项目架构采用 SpringBoot + Vue 的前后端分离模式开发，使用 SpringDataJPA 结合 Hibernate 完成业务逻辑，层次间的依赖关系自下到上，相互解耦。系统对接了多个第三方平台 API，在收集数据的同时对数据进行分析和优化，并根据专有的算法实现专属指标的计算和存储。不仅完成本系统的接口实现，同时还提供了大量的免费开放 API ，为公司后续业务提供数据 API 和技术支持。'
                    ]
                },
                {
                    name: 'Social Investment Platform (SiP)',
                    period: '2018年7月 - 2019年5月',
                    technology: 'SpringBoot + Vue + MySQL',
                    imageUrl1: '/static/images/projects/sip/1.png',
                    imageUrl2: '/static/images/projects/sip/2.png',
                    imageUrl3: '/static/images/projects/sip/3.png',
                    projectLink: 'https://iob.community',
                    descriptions: [
                        'SiP是一个投资者分享交易心得和市场新闻的社交网络平台，旨在为用户提供一个可以获得平台专属奖励（IOB 代币）的社区。平台共包含用户中心、发帖评论、奖励机制、系统设置等多个模块。本项目采用 SpringBoot + Vue 的前后端分离模式开发，采用 SpringDataJPA、Hibernate 等框架实现业务逻辑和数据库交互，同时采用 Redis 作为帖子等相关数据的缓存。前端页面则采用主流的无限数据流下滑方式进行帖子的分页加载，使用户体验达到最佳。用户可以通过发帖、评论、点赞等方式获取平台独特的代币奖励，用于公司后期业务的使用。'
                    ]
                }
            ]
        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>
/* 隐藏滚动条 */
::-webkit-scrollbar{ display: none }

.description {
    overflow: auto;
    max-height: 245px;
}

</style>


// WEBPACK FOOTER //
// src/components/Project.vue